import { useFeatureFlag } from '@vimeo/viewer-showcase-ui/hooks/use-feature-flag';

import { FEATURED_FLAG_KEYS } from '../utils/constants';
import { useCustomizeControls } from './use-customize-controls';

/**
 * Determines whether to show the new customize controls.
 *
 * This hook checks for the `canViewShowcaseCustomizeControls` capability
 * and also checks for the `SHOW_NEW_CUSTOMIZE_CONTROLS` feature flag.
 *
 * @returns {boolean} - True if the new customize controls should be shown, false otherwise.
 */
export const useShowNewCustomizeControls = (): boolean => {
  const canViewShowcaseCustomizeControls = useCustomizeControls();
  const isFeatureFlagEnabled = useFeatureFlag(
    FEATURED_FLAG_KEYS.SHOW_NEW_CUSTOMIZE_CONTROLS,
    false,
  );
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has(FEATURED_FLAG_KEYS.SHOW_NEW_CUSTOMIZE_CONTROLS)) {
    return isFeatureFlagEnabled;
  } else {
    return Boolean(canViewShowcaseCustomizeControls) || isFeatureFlagEnabled;
  }
};
